import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/plots";
import { useSelector } from "react-redux";
import GetPlanGroupStatsApi from "../../api/performance/GetPlanGroupStatsApi";
import { SimpleLoader } from "../sub/Loaders";
import { useNavigate } from "react-router-dom";
import { getPluralString } from "../../helpers/wordHelpers";

function PlanGroupStats() {
  const [planGroupsStats, setPlanGroupsStats] = useState([]);

  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const topPlanState = useSelector((state) => state.topPlanState.value);

  const positionState = useSelector((state) => state.positionState.value);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  useEffect(() => {
    getPlanGroupPerformanceStats();
  }, [perfCycleState]);

  async function getPlanGroupPerformanceStats() {
    setLoading(true);
    const apiResponse = await GetPlanGroupStatsApi(
      positionState?.id,
      perfCycleState?.id
    );

    if (apiResponse.success) {
      setPlanGroupsStats(apiResponse?.data);
      setLoading(false);
    }
  }

  const config = {
    data: planGroupsStats,
    isStack: true,
    xField: "planGroup",
    yField: "value",
    seriesField: "type",
    label: {
      position: "middle",
      // 'left', 'middle', 'right'
      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
    },

    width: 200,
    color: ({ type }) => {
      if (type === "At Risk") {
        return "#f50";
      } else if (type === "On Track") {
        return "#87d068";
      }
      return "#FAB324";
    },
    onReady: (plot) => {
      plot.on("element:click", (args) => {
        navigate(`/top-plans?planGroup=${args?.data?.data?.planGroupId}`);
      });
    },
  };
  return (
    <div>
      {loading ? (
        <SimpleLoader />
      ) : (
        <div className="border p-5 rounded-md">
          <div className="mb-4">
            Plan groups {getPluralString(topPlanState) || "Top plans"}
          </div>
          <Column {...config} />
        </div>
      )}
    </div>
  );
}

export default PlanGroupStats;
